export const createQueryParamsFromObject = (object) => {
    if (!object) {
        return;
    }
    const convertToSnakeCase = Object.entries(object).reduce(
        (prev, [key, value]) => ({
            ...prev,
            [key
                .split(/(?=[A-Z])/)
                .join('_')
                .toLowerCase()]: value
        }),
        {}
    );

    const params = new URLSearchParams();
    const keys = Object.keys(convertToSnakeCase);

    for (let item of keys) {
        if (convertToSnakeCase[item] !== null && convertToSnakeCase[item] !== undefined) {
            params.append(item, convertToSnakeCase[item]);
        }
    }
    return params;
};
